export enum ProcessActionType {
  SHOW_SCREEN = <any>'showScreen'
}
